import I18n from 'i18n'
import { MyAxios as axios } from './MyAxios'
import moment from 'moment'
import { URL_LANGUAGE_PARAM } from './common/Constants'
import { FALLBACK_LOCALE, supportedLocales, toSupportedLocale } from './common/Locales'
import queryString from 'query-string'
import _ from 'lodash'
import { Cookies } from 'react-cookie'
// translations.json is generated by the i18n-js gem (`i18n export`) and keyed
// by locale, e.g. { en: {...}, nl: {...} }.
I18n.translations = require('../../../public/javascripts/translations.json')
// Missing translations fall back to English. nl has no fallback (as in Rails).
// Every locale needs its own entry: without one, i18n-js uses the chain of the current locale, so an explicit
// { locale: 'nl' } would resolve through e.g. ['fi', 'en'] for a Finnish user.
supportedLocales.forEach(locale => {
  I18n.locales[locale] = locale === 'nl' || locale === FALLBACK_LOCALE
    ? [locale]
    : [locale, FALLBACK_LOCALE]
})

const getLocaleFromUrl = () => {
  const url = window.location.search
  const urlParams = queryString.parse(url)
  const lang = _.get(urlParams, URL_LANGUAGE_PARAM)
  lang && setLocaleInCookie(lang)
  return lang
}

const getLocaleFromCookie = () => {
  return new Cookies().get('preferredLocale')
}

const setLocaleInCookie = (locale) => {
  new Cookies().set('preferredLocale', locale)
}

const getBrowserLocale = () => {
  return window.navigator.userLanguage || window.navigator.language
}

const getDefaultLocale = () => {
  const locale = getLocaleFromUrl() || getLocaleFromCookie() || getBrowserLocale()
  // default NL for test environment, otherwise choose default
  return window.navigator.webdriver ? 'nl' : toSupportedLocale(locale) || FALLBACK_LOCALE
}

/**
 * Default to NL locale if the requester is a headless browser.
 * This is required because for some reason Chromium does not want to change its preferred locale
 * A 'nl' locale is required for testing
 */
const DEFAULT_LOCALE = getDefaultLocale()

I18n.locale = DEFAULT_LOCALE
moment.locale(DEFAULT_LOCALE)

const loadLocaleAsync = () => {
  return new Promise((resolve, reject) => {
    const locales = axios.get('/api/v1/locales')
    locales.then((result) => {
      const locale = result.data.current
      if (locale !== null) {
        moment.locale(locale)
        I18n.locale = locale
      } else {
        moment.locale(DEFAULT_LOCALE)
        I18n.locale = DEFAULT_LOCALE
      }
      resolve(I18n)
    })
  })
}

const loadFromGivenLocale = givenLocale => {
  const locale = givenLocale
  if (locale !== null) {
    moment.locale(locale)
    I18n.locale = locale
  } else {
    moment.locale(DEFAULT_LOCALE)
    I18n.locale = DEFAULT_LOCALE
  }
}

export const I18nLoader = {
  load: () => {
    // returns a promise, but since load() doesnt return anything we can just wait
    // for it to be resolved in the background
    loadLocaleAsync()
  },
  loadAsync: () => loadLocaleAsync(),
  loadFromGiven: (givenLocale) => loadFromGivenLocale(givenLocale)
}
